import { render, staticRenderFns } from "./StagingCitationForm.vue?vue&type=template&id=58af28a3"
import script from "./StagingCitationForm.vue?vue&type=script&lang=ts"
export * from "./StagingCitationForm.vue?vue&type=script&lang=ts"
import style0 from "./StagingCitationForm.vue?vue&type=style&index=0&id=58af28a3&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports